module.exports = __webpack_public_path__ + "img/click-inquiry.aece1030.svg";